export const DateFormat = {
  Default: 'MM/DD/YYYY',
  DatePickerFormat: 'YYYY-MM-DD',
  ExportDateFormat: 'YYYY-MM-DDTHH-MM-SS',
};
export const DateTimeFormat = {
  Default: 'l hh:mm A',
  SimpleTimeFormat: 'h:mm A',
};

export const TimeFormat = {
  Default: 'HH:mm:ss',
};
